import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'Once approved by an admin, the card will be capped at the indicated budget.',
    fields: {
      amount: {
        errors: {
          max: 'The amount cannot exceed {max} €',
          min: 'The amount cannot be less than {min} €',
        },
        hint: 'You will be able to spend this amount in one or multiple times',
        label: 'Amount',
        placeholder: 'Indicate the amount including taxes',
      },
      description: {
        label: 'Description',
        placeholder: 'Indicate the reason for your request',
      },
    },
    submit: 'Submit',
    title: 'Set up your budget card',
  },
  fr: {
    description:
      'Une fois approuvée par un admin, la carte sera plafonnée au budget indiqué.',
    fields: {
      amount: {
        errors: {
          max: 'Le montant ne peut pas dépasser {max} €',
          min: 'Le montant ne peut pas être inférieur à {min} €',
        },
        hint: 'Maximum 5000 €. Vous pourrez dépenser ce montant en une fois ou plusieurs fois',
        label: 'Budget demandé',
        placeholder: 'Indiquez le montant TTC',
      },
      description: {
        label: 'Description de la dépense',
        placeholder: 'Indiquez la raison de votre demande',
      },
    },
    submit: 'Envoyer la demande',
    title: 'Paramétrez votre carte virtuelle à budget',
  },
} as const);

export default locales;
